import "core-js/modules/es.array.concat";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getUniUserList, getChnnelList, deleChannel } from "@/api/loginConfig/userChannel";
import adduniUPage from "./components/adduniUserChannel";
export default {
  name: "unifiedUser",
  components: {
    adduniUPage: adduniUPage
  },
  data: function data() {
    return {
      dialog: false,
      num: 1,
      searchgames: [],
      searchplatforms: [],
      searchchannels: [],
      searchpkgs: [],
      tableTitle: [],
      advchannels: [],
      advLocation: [],
      addrelationType: false,
      gameId: "",
      searchData: {
        channel: ""
      },
      searchMark: {
        page: 1,
        channel: "" // ad_placement: "",

      },
      total: 0,
      page: 0,
      pagrSize: 10,
      tableData: [],
      tableLtv: [],
      tableDate: "",
      show: false,
      showing: false,
      dates: [],
      datas: []
    };
  },
  created: function created() {
    this.getAllChannel();
  },
  methods: {
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    getAllChannel: function getAllChannel() {
      var _this = this;

      getUniUserList().then(function (res) {
        _this.searchchannels = res.data;
      });
    },
    channelchange: function channelchange(val) {
      this.searchMark.channel = val;
      this.searchMark.page = 1;
    },
    // 新增弹窗
    dialogShow: function dialogShow() {
      this.dialog = true;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchClick();
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.page = this.searchMark.pag;
      getChnnelList(this.searchMark).then(function (res) {
        if (res.status == 200) {
          var list = ['channel'];
          _this2.tableData = res.data.data.length ? _this2.$utils.dataConversion(res.data.data, list) : [];
          _this2.total = res.data.total || 0;
        }
      });
    },
    handleSource: function handleSource(id, num) {
      var _this3 = this;

      this.showing = true;
      this.num = num;
      this.addrelationType = true;
      this.$nextTick(function () {
        _this3.$refs.addrelationType.init(id, num);
      });
    },
    // 删除配置
    deleHandle: function deleHandle(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleChannel({
                  id: id
                }).then(function (res) {
                  _this4.searchClick();

                  _this4.$message({
                    type: "success",
                    message: res.message
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    // 重置密钥
    handleJoinPeople: function handleJoinPeople(a) {
      var tid = {
        id: a.id
      };
      this.$alert("<strong>\u5BC6\u94A5ID:<i>".concat(a.secret_key_id, "</i></strong></br><strong>\u5BC6\u94A5key:<i>").concat(a.secret_key_key, "</i></strong>"), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "取消"
      }).then(function () {
        dangerouslyUseHTMLString: false;
      });
    }
  }
};